export default "/img/NU.7a194ba9ba91b771ac45efb4e2005afe.png";